import { render, staticRenderFns } from "./DealArrangement.vue?vue&type=template&id=32c61d3b&"
import script from "./DealArrangement.vue?vue&type=script&lang=ts&"
export * from "./DealArrangement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c61d3b')) {
      api.createRecord('32c61d3b', component.options)
    } else {
      api.reload('32c61d3b', component.options)
    }
    module.hot.accept("./DealArrangement.vue?vue&type=template&id=32c61d3b&", function () {
      api.rerender('32c61d3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/DealArrangement.vue"
export default component.exports